import { AnimatePresence } from 'framer-motion'
import classNames from 'classnames'
import { light } from '@fortawesome/fontawesome-svg-core/import.macro'
import { useEffect } from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useSyncTrainingPeriod, useTrainingPeriodStore } from 'models/model'
import { NEW } from 'models/model/model.utils'
import { Button, Icon, Text, TimePickerInput } from 'src/components/ui'
import { FetchModel } from 'src/services'
import { timeRangeOrPeriodToTimeRange } from 'src/utility/time'
import useTimeRange from 'src/contexts/timeRange'
import { ExcludedPeriods, TrainingPeriodLabel } from './components'

type Props = {
  model: FetchModel
}
export function TrainingPeriod({ model }: Props): JSX.Element {
  const {
    isExcludedPeriodOpen,
    trainingPeriod,
    setIsExcludedPeriodOpen,
    setTrainingPeriod,
  } = useTrainingPeriodStore()
  const { trainingPeriod: trainingPeriodFlag } = useFlags()
  const { setTimeRange } = useTimeRange()

  useEffect(() => {
    if (model.state !== NEW || !trainingPeriodFlag) return
    setTimeRange(timeRangeOrPeriodToTimeRange(trainingPeriod))
  }, [model.state, setTimeRange, trainingPeriod, trainingPeriodFlag])

  useSyncTrainingPeriod({ model })

  if (model.state !== NEW) {
    return <TrainingPeriodLabel model={model} />
  }

  return (
    <div className="flex flex-col gap-xs">
      <div className="flex flex-col gap-2xs large:flex-row large:items-center">
        <Text bold>Training Period: </Text>
        <div className="flex items-center">
          <TimePickerInput
            value={trainingPeriod}
            isLive={false}
            onChange={setTrainingPeriod}
            maxDate={new Date()}
            position="left"
            showTimeOption={false}
          />
          <div
            className="flex items-center"
            onClick={() => setIsExcludedPeriodOpen(!isExcludedPeriodOpen)}
          >
            <Button
              variant="tertiary"
              title="Excluded periods"
              className="!pr-xs"
            />
            <Icon
              icon={light('chevron-down')}
              className={classNames(
                'transition',
                isExcludedPeriodOpen && 'scale-y-[-1]',
              )}
            />
          </div>
        </div>
      </div>
      <AnimatePresence>
        {isExcludedPeriodOpen && <ExcludedPeriods model={model} />}
      </AnimatePresence>
    </div>
  )
}
